document.addEventListener('click', function(e) {
  if (!e.target.classList.contains('tab-btn')) return;

  const modal = e.target.closest('.product-popup-modal__content-info');

  modal.querySelectorAll('.tab-btn').forEach(btn => {
    btn.classList.remove('active');
  });

  modal.querySelectorAll('.tab-content').forEach(tab => {
    tab.classList.remove('active');
  });

  e.target.classList.add('active');

  const targetTab = modal.querySelector(
    '#' + e.target.getAttribute('data-tab')
  );

  if (targetTab) {
    targetTab.classList.add('active');
  }
});